if (!process.env.REACT_APP_BACKEND_URL) throw new Error('REACT_APP_BACKEND_URL is required');
export const ONBOARDING_API = `${process.env.REACT_APP_BACKEND_URL}/api/onboarding`;
export const onboardingError = (error, fallback) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => `${Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : 'Field'}: ${item.msg || 'Invalid value'}`).join(' ');
  return fallback;
};